import React, { useState, useEffect } from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useRenameCompanyRole, CompanyRoleListItem } from 'hooks/api'

import { Stack } from '@mui/material'

import { Modal, Button, Input } from '@repo/ui'

interface RenameRoleModalProps {
  role: CompanyRoleListItem | null | undefined
  open: boolean
  onClose: () => void
  onRenamed?: () => void
}

export const RenameRoleModal = ({ role, open, onClose, onRenamed }: RenameRoleModalProps) => {
  const { open: notification } = useSnackbar()
  const [name, setName] = useState('')

  useEffect(() => {
    if (open && role) {
      setName(role.name)
    }
  }, [open, role])

  const { mutate: renameRole, isPending } = useRenameCompanyRole({
    onSuccess: () => {
      notification({ type: 'success', title: 'Role renamed' })
      onClose()
      onRenamed?.()
    },
    onError: (error: any) => {
      notification({ type: 'error', title: getErrorMessage(error) })
    },
  })

  const handleSubmit = () => {
    if (!role || !name.trim()) return
    renameRole({ id: role.id, name: name.trim() })
  }

  return (
    <Modal
      title="Rename role"
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button variant="secondary" onClick={onClose} disabled={isPending}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!name.trim() || name.trim() === role?.name || isPending}
          >
            {isPending ? 'Saving...' : 'Save'}
          </Button>
        </>
      }
    >
      <form
        onSubmit={(e) => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        <Stack spacing={4}>
          <Input
            label="Role name"
            placeholder="Enter"
            value={name}
            onChange={(value: string) => setName(value)}
          />
          {/* Lets Enter submit the form (handleSubmit no-ops on an empty name). */}
          <button type="submit" style={{ display: 'none' }} aria-hidden />
        </Stack>
      </form>
    </Modal>
  )
}
